import { render, staticRenderFns } from "./AccordionLoading.vue?vue&type=template&id=921317e2&scoped=true&lang=pug"
import script from "./AccordionLoading.vue?vue&type=script&lang=ts"
export * from "./AccordionLoading.vue?vue&type=script&lang=ts"
import style0 from "./AccordionLoading.vue?vue&type=style&index=0&id=921317e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921317e2",
  null
  
)

export default component.exports